export const compose =
  (...funcs) =>
  () =>
    funcs.forEach((fn) => fn());

export const shortGender = (gender) => {
  switch (gender) {
    case 'MALE':
      return 'm';
    case 'FEMALE':
      return 'f';
    default:
      return undefined;
  }
};

export const toUserList = (users) =>
  users.map((user) => {
    if (user) {
      return {
        name: user.displayName,
        badgeText: user.badgeText,
        badgeType: user.badgeType,
        isNewItem: user.isNewItem,
        gender: shortGender(user.gender),
        company: user?.occupations?.[0]?.headline,
        position: user?.occupations?.[0]?.subline,
        imgSrc: user?.imageUrl?.[0]?.url,
        url: `/profile/${user.pageName}`,
      };
    }

    return null;
  });

export const getImageSrcSet = ({ small, big }) =>
  small && big ? `${small} 1x, ${big} 2x` : null;

export const t = (intl, id) => {
  return id ? intl.formatMessage({ id }) : '';
};

export const pageTitle = (title) => (title ? `${title} | XING` : 'XING');

export const isKlartextByArticleType = (typename) =>
  typename === 'ContentKlartextKlarticle';
